import React, { useCallback } from "react";

import { Button } from "~/ui";
import { Modal } from "~/ui/legacyFellowIndex";

type RemoveModalProps = {
	onClose: (result?: boolean) => void;
	userName: string;
	isSelf: boolean;
};

export function RemoveAccessModal(props: RemoveModalProps) {
	const { onClose, userName, isSelf } = props;
	const cancel = useCallback(() => onClose(), [onClose]);

	const remove = useCallback(() => {
		onClose(true);
	}, [onClose]);

	const removeText = isSelf ? "leave" : `remove ${userName}`;

	return (
		<Modal onClose={cancel}>
			<Modal.Header onClose={cancel} noBottomBorder>
				<Modal.Title>Are you sure?</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div>{`Are you sure you want to ${removeText}? ${
					isSelf ? "You" : userName
				} may not be able to access these notes anymore.`}</div>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={cancel}>Cancel</Button>
				<Button variant="destructive" onClick={remove}>
					{isSelf ? "Leave" : "Remove"}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
